<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path fill="currentColor" fill-rule="evenodd" d="M19.5 12 6 3v18l13.5-9Z" clip-rule="evenodd" /></svg
>
